/**
 * Bridge to the tiny native ApkInstaller plugin (android/.../ApkInstallerPlugin.java).
 *
 * There is no first-party Capacitor plugin for launching the system package
 * installer, and the community ones are Capacitor 3/4-era and unmaintained. The
 * work is only a few lines of well-understood Android intent code, so we ship our
 * own rather than take on an unmaintained dependency. On non-Android platforms the
 * method simply isn't implemented; callers guard with Capacitor.isNativePlatform()
 * (see canUpdate() in updateStore.ts) so it's never invoked off-device.
 */
import { registerPlugin } from '@capacitor/core';

export interface ApkInstallerPlugin {
  /**
   * Hand a downloaded APK to the OS installer. `path` is the file URI returned by
   * Filesystem.getUri for the downloaded APK (a file:// path inside our cache dir).
   * The plugin wraps it in a FileProvider content:// URI and fires the install
   * intent. Rejects with code 'UNKNOWN_SOURCES_DENIED' if the user hasn't yet
   * allowed installs from this app — in that case it opens the relevant system
   * settings screen, and the caller should ask the user to allow it and retry.
   */
  install(options: { path: string }): Promise<void>;
}

export const ApkInstaller = registerPlugin<ApkInstallerPlugin>('ApkInstaller');
